export default __webpack_public_path__ + "a64c4a2dfda65f0fff23ed34daa74721.svg";